 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"fe357c2d": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"fe357c2d": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0003fe2d":"competitor-bg-mob-dark","010b6b6c":"tournament-Tournament","012c2b17":"betslip-module","24f6d19a":"filters-module","2b0fe3d5":"competitor-bg-dark","3e6192e5":"freebet-module","40ef4384":"components-TournamentInfo","42ac9149":"bets-history-module","55769d7e":"CMS-module","71ecde20":"components-Carousel","76f18ccc":"esport-icons","8e3f5bc4":"classic-icons","92dc1b36":"components-MultiCarousel","9c7ab3d0":"sport-bg-dark","b8bb3601":"outright-module","bdc83adc":"match-module","c4a3da56":"components-PromoMatch","c4fed2f7":"tournament-bg-dark","d9409889":"cashout-module","ddc824f7":"stream-module","e6e4ca41":"components-Helper","e9ba59fc":"tournament-bg-mob-dark","f10844a7":"sport-bg-mob-dark"}[chunkId]||chunkId) + "-" + {"0003fe2d":"8a0f45a6","010b6b6c":"279e7346","012c2b17":"3f074250","24f6d19a":"8c07a6ff","2b0fe3d5":"0170b892","3e6192e5":"d7c4a1b3","40ef4384":"52ffaa6f","42ac9149":"397582a5","55769d7e":"ea1185a7","71ecde20":"6562da01","76f18ccc":"1fa5bf29","8e3f5bc4":"38ba3e51","92dc1b36":"2c4c6472","9c7ab3d0":"3483d86e","b8bb3601":"a9a010cf","bdc83adc":"634808a0","c4a3da56":"80b9201d","c4fed2f7":"cbc16f6b","d9409889":"d4f7c0bd","ddc824f7":"51851ddd","e6e4ca41":"749a1b1a","e9ba59fc":"1a43936c","f10844a7":"dd113145"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"010b6b6c":1,"012c2b17":1,"24f6d19a":1,"3e6192e5":1,"42ac9149":1,"55769d7e":1,"71ecde20":1,"92dc1b36":1,"b8bb3601":1,"bdc83adc":1,"c4a3da56":1,"d9409889":1,"ddc824f7":1,"e6e4ca41":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0003fe2d":"competitor-bg-mob-dark","010b6b6c":"tournament-Tournament","012c2b17":"betslip-module","24f6d19a":"filters-module","2b0fe3d5":"competitor-bg-dark","3e6192e5":"freebet-module","40ef4384":"components-TournamentInfo","42ac9149":"bets-history-module","55769d7e":"CMS-module","71ecde20":"components-Carousel","76f18ccc":"esport-icons","8e3f5bc4":"classic-icons","92dc1b36":"components-MultiCarousel","9c7ab3d0":"sport-bg-dark","b8bb3601":"outright-module","bdc83adc":"match-module","c4a3da56":"components-PromoMatch","c4fed2f7":"tournament-bg-dark","d9409889":"cashout-module","ddc824f7":"stream-module","e6e4ca41":"components-Helper","e9ba59fc":"tournament-bg-mob-dark","f10844a7":"sport-bg-mob-dark"}[chunkId]||chunkId) + "-" + {"0003fe2d":"31d6cfe0","010b6b6c":"6e3dbadd","012c2b17":"787f37db","24f6d19a":"6a6aadc5","2b0fe3d5":"31d6cfe0","3e6192e5":"17215159","40ef4384":"31d6cfe0","42ac9149":"016dd5b1","55769d7e":"4ed1b63c","71ecde20":"edab2c34","76f18ccc":"31d6cfe0","8e3f5bc4":"31d6cfe0","92dc1b36":"18555bf3","9c7ab3d0":"31d6cfe0","b8bb3601":"6fa4431e","bdc83adc":"878e74a1","c4a3da56":"912aa549","c4fed2f7":"31d6cfe0","d9409889":"d5a152d7","ddc824f7":"94674385","e6e4ca41":"35a9f5db","e9ba59fc":"31d6cfe0","f10844a7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				document.body.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;

 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([147,"e3bdfa21"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
